module.exports = __webpack_public_path__ + "static/media/001-compass.4d53f63b.svg";